export default __webpack_public_path__ + "static/media/yammer.c707c3b3.svg";